<script setup lang="ts">
import { onMounted, ref, watchEffect, reactive, watch } from 'vue';
import Dropzone from 'dropzone';

const removeFilesTrigger = defineModel<boolean>();
const dropzoneInstance = ref();
const fileMap = reactive(new Map());
const dropzoneElement = ref(null);
const emit = defineEmits(['file-add']);

onMounted(() => {
  Dropzone.autoDiscover = false;
  dropzoneInstance.value = new Dropzone(dropzoneElement.value, {
    url: '/file/post',
    dictDefaultMessage: '',
    clickable: '.upload-btn',
    maxFiles: 1,
    maxFilesize: 10,
    acceptedFiles: 'image/gif, image/png, image/jpg, image/jpeg',
    dictFileTooBig: 'JPG, PNG, or GIF (Max 10MB per file)',
    dictInvalidFileType: `JPG, PNG, or GIF (Max 10MB per file)`,
    previewTemplate: `
            <div class="dz-preview file-preview">
              <div>
                <span data-dz-name></span>
                <div class="dz-error-message"><span data-dz-errormessage></span></div>
              </div>
              <div class="dz-success-mark"><span class="material-icons-outlined" data-dz-remove>delete</span></div>
              <div class="dz-error-mark"><span class="material-icons-outlined" data-dz-remove>close</span></div>
            </div>
        `,
    thumbnailMethod: 'contain',
    init: function () {
      this.on('success', (file: any, response: any) => {
        const { mage_name } = response;
        fileMap.set(file.upload.uuid, mage_name);
      });

      this.on('removedfile', function (file: any) {
        fileMap.delete(file.upload.uuid);
      });
    },
  });
});

watchEffect(() => {
  const arr = Array.from(fileMap.values());
  emit('file-add', arr);
});
watch(removeFilesTrigger, (value) => {
  if (value) {
    dropzoneInstance.value.removeAllFiles();
    removeFilesTrigger.value = false;
  }
});
</script>

<template>
  <form
    ref="dropzoneElement"
    class="dropzone single-file"
  >
    <button
      class="btn wide btn-sm upload-btn"
      type="button"
    >
      Upload Profile Picture
    </button>
    <div class="single-file__message">JPG, PNG, or JPEG (Max 10MB per file)</div>
  </form>
  <p class="text-s mt-8 mb-0 text-subtle-black">Add a photo of yourself to personalize and enhance your story.</p>
</template>
